import React from 'react';
import styled from 'styled-components';
import IndicatorBox from '../../../../components/IndicatorBox';
import Card from '../../../../components/Card';
import CardHeader from '../../../../components/CardHeader';
import { I18n } from 'react-redux-i18n';

const KeyIndicatorsCardContainer = styled.div`
  > * {
    height: calc(100% - 60px);
  }

  .exportButtonContainer {
    padding-bottom: 10px;
    margin-top: 10px;
  }

  .siteInfosText {
    opacity: 0.5;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-size: 12px;
    color: ${(props) => props.theme.colors.dark};
    margin-top: 11px;
    margin-bottom: 20px;
  }

  .boldText {
    font-family: ${(props) => props.theme.fonts.oswald};
  }

  .recapIndicatorsContainer {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin-bottom: 118px;
  }

  @media (max-width: ${(props) =>
      props.theme.devices.isTablet ? '0px' : '845px'}) {
    .recapIndicatorsContainer {
      grid-template-columns: 1fr;
    }
  }
`;

const KeyIndicatorsCard = function ({ indicators }) {
  return (
    <KeyIndicatorsCardContainer>
      <Card>
        <CardHeader
          title={I18n.t('primeur.recap.indicators.title')}
          fontSize="20px"
          iconRight
        />
        <div className="recapIndicatorsContainer">
          {indicators.map((indicator, index) => (
            <IndicatorBox key={index} {...indicator} />
          ))}
        </div>
      </Card>
    </KeyIndicatorsCardContainer>
  );
};

export default KeyIndicatorsCard;
